import React from 'react';

import loading from './loading.svg';


const Loading = () => (
    <div className="loading">
        <img src={loading} alt="loading"/>
    </div>
);

Loading.propTypes = {};
Loading.defaultProps = {};

export default Loading;



// WEBPACK FOOTER //
// ./src/arteia-js/components/Loading/index.js